import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { getFriendlyChatName } from '../../../libs/hooks/useChat';
import { ChatMessageType } from '../../../libs/models/ChatMessage';
import { useAppSelector } from '../../../redux/app/hooks';
import { RootState } from '../../../redux/app/store';
import { Conversations } from '../../../redux/features/conversations/ConversationsState';
import { customTokens } from '../../../styles';
import { ChatListItem } from './ChatListItem';

const useClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: tokens.spacingVerticalXS,
    },
    header: {
        marginTop: 0,
        marginBottom: tokens.spacingVerticalSNudge,
        marginLeft: tokens.spacingHorizontalL,
        marginRight: tokens.spacingHorizontalL,
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase300,
        color: customTokens.colorTextLight,
        lineHeight: '22px',
    },
});

interface IChatListSectionProps {
    header?: string;
    conversations: Conversations;
    selectedAgentId: string;
}

export const ChatListSection: React.FC<IChatListSectionProps> = ({ header, conversations, selectedAgentId }) => {
    const classes = useClasses();
    const { selectedId } = useAppSelector((state: RootState) => state.conversations);
    const keys = Object.keys(conversations);

    return keys.length > 0 ? (
        <div className={classes.root}>
            <Text className={classes.header}>{header}</Text>
            {keys.map((id) => {
                const convo = conversations[id];
                const messages = convo.messages;
                const lastMessage = messages[convo.messages.length - 1];
                const isSelected = id === selectedId;
                return (
                    <ChatListItem
                        id={id}
                        key={id}
                        isSelected={isSelected}
                        header={getFriendlyChatName(convo)}
                        preview={
                            messages.length > 0
                                ? lastMessage.type === ChatMessageType.Document
                                    ? 'Bir dosya gönderildi'
                                    : lastMessage.type === ChatMessageType.Plan
                                      ? 'Önerilen planı görüntülemek için tıklayın'
                                      : lastMessage.content
                                : 'Sohbete başlamak için tıklayın'
                        }
                        botProfilePicture={convo.botProfilePicture}
                        selectedAgentId={selectedAgentId}
                    />
                );
            })}
        </div>
    ) : null;
};
